import { atom } from 'jotai';
import { Address } from '../Models/Address';
export var LoginType;
(function (LoginType) {
    LoginType[LoginType["Normal"] = 0] = "Normal";
    LoginType[LoginType["Checkout"] = 1] = "Checkout";
    LoginType[LoginType["Signup"] = 2] = "Signup";
    LoginType[LoginType["SignupCheckout"] = 3] = "SignupCheckout";
})(LoginType || (LoginType = {}));
// export const LoginTypeAtom = atom<LoginType>(LoginType.Normal);
export var LoginOverlayVisible = atom(false);
export var AccountOverlayVisible = atom(false);
export var CheckoutOverlayVisible = atom(false);
export var MatureContentVisible = atom(false);
export var LoginTypeStore = (function () {
    var loginType = LoginType.Normal;
    var getLoginType = function () { return loginType; };
    var setLoginType = function (type) {
        if (loginType === LoginType.Checkout && type === LoginType.Signup) {
            loginType = LoginType.SignupCheckout;
        }
        else {
            loginType = type;
        }
        // console.log('type is', loginType);
    };
    return { getLoginType: getLoginType, setLoginType: setLoginType };
})();
export var CheckoutBillingAddressAtom = atom(Address.FromPartial({}));
export var CheckoutShippingAddressAtom = atom(Address.FromPartial({
    country: 'US',
}));
export var ResetBillingAddressAtom = atom(null, function (get, set) {
    set(CheckoutBillingAddressAtom, Address.FromPartial({}));
});
export var ResetShippingAddressAtom = atom(null, function (get, set) {
    set(CheckoutShippingAddressAtom, Address.FromPartial({ country: 'US' }));
});
export var CheckoutOrderShippingMethodAtom = atom(false);
export var CheckoutSetBillingSameAsShipping = atom(true);
export var CheckoutCountries = atom(false);
